import { render, staticRenderFns } from "./CommunityCompanySanjaeDetail.vue?vue&type=template&id=11815bd3&scoped=true"
import script from "./CommunityCompanySanjaeDetail.vue?vue&type=script&lang=js"
export * from "./CommunityCompanySanjaeDetail.vue?vue&type=script&lang=js"
import style0 from "./CommunityCompanySanjaeDetail.vue?vue&type=style&index=0&id=11815bd3&prod&scoped=true&lang=css"
import style1 from "./CommunityCompanySanjaeDetail.vue?vue&type=style&index=1&id=11815bd3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11815bd3",
  null
  
)

export default component.exports